import _ from '@lodash';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import useToast from '@fuse/hooks/useToast';
import Tooltip from '@material-ui/core/Tooltip';
import 'ag-grid-enterprise';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { isArray } from "lodash";
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import DeleteConfirmModal from 'helper/DeleteConfirm';
import ActivityAgGridListing from '@fuse/components/ActivitieLogs/activitiesAgGridListing';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import { openFormViewerDialog, setFromData } from '../store/formViewDialogReducer';

function ListView(props) {
	const table_name = "MODEL_ATTRIBUTES";
	const router = useRouter();
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	const gridRef = useRef();
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const [modalData, setModalData] = useState(null)
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
	const [displayButton, setDisplayButton] = useState(false);
	const [isGridReady, setIsGridReady] = useState(0)
	const skipHeader = [
		"id", "platform_customer_id", "user_companies_id",
		"created_at", "updated_at", "original_info"
	]
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [tabValue, setTabValue] = useState(0)
	const [groupByArr, setGroupByArr] = useState([])
	const [logs, setLogs] = useState([]);
	const [loadingActivityLog, setLoadingActivityLog] = useState(false);
	const [filterApplied, setFilterApplied] = useState(false);
	const [gridApi, setGridApi] = useState(null);

	const query_data = useSelector(
		(state) => state.reportApp.reportViewDialogReducer.quick_filter
	);
	const tab_value = useSelector(
		(state) => state.reportApp.reportViewDialogReducer.tab_value
	);

	function handelEdit(data) {
		dispatch(setFromData(data))
		dispatch(openFormViewerDialog())
	}

	const tableHeaders = [
		"model_attribute", "source"
	];

	function handelDelete(data) {
		setOpenDeleteDialog(true)
		setModalData(data)
	}

	function handleClose() {
		setOpenDeleteDialog(false)
		setModalData(null)
	}

	function handleConfirm() {
		axios.delete(`/model-custom-attributes/delete/${modalData.id}`).then(response => {
			handleClose()
			props.refresh()
			toast.success(response.data.message)
		}).catch(err => {
			console.log('err', err.response);
			toast.error(err.response.data.message ?? 'Something went wrong!')
		})
	}


	const onGridReady = (params) => {
		gridRef.current = params
		setGridApi(params);

		// props.endUsersAccounts.forEach((list) => {
		// 	for(let [fieldName, value] of Object.entries(list)){
		// 		if(value === '') list[fieldName] = `No ${formatString(fieldName)}`
		// 	}
		// })
		if (router.query.report_name === undefined) {
			loadInitialState(params);
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]))
		} else {
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}

	// const onGridSizeChanged = ()=>{
	// 	setWindowHeight(window.innerHeight - 290);
	// }

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		// to show No result found in column filter
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)

		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if (total_rows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}

	function getReport(event) {
		const { report_name } = router.query;
		const table_name = "model attribute";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
			.then(results => {
				const model = JSON.parse(results.data.data.filter);
				event.api.setFilterModel(model);
				const row_model = JSON.parse(results.data.data.row_model);
				event?.api.applyColumnState({ state: row_model });
			})
			.catch(err => {
				console.log(err);
			})
	}

	function loadInitialState(params) {
		axios.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then(results => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current = { ...gridRef.current, filterModelArr: filter }
					params?.api.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
					if (Object.keys(filter)?.length) {
						setFilterApplied(true)
					}
				}
			})
			.catch(err => {
				console.log(err);
			})
	}

	function saveView(rows, filter, filterModelArr = null) {
		if (isArray(rows) && !rows.length) return
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter: JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}

		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	const onColumnMoved = (params) => {
		const rows = params.api.getColumnState();
		saveView(rows);
		dispatch(setrowGroupModel(rows))
	}

	function onColumnVisible(params) {
		const rows = params.api.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			saveView(params.api.getColumnState());
		}
	}
	function onSortChanged(params) {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows));
			saveView(rows);
		}
	}

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();
		if (groupedColumns.length === 0) setGroupByArr([]);
		else setGroupByArr(groupedColumns);
		if (router.query.report_name === undefined) {
			const rows = event.api.getColumnState();
			const first_row = rows[0];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
				dispatch(setrowGroupModel(rows));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
			}
		}
		// auto size group columns
		// onRowGroupOpenedAutoSize();
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
			dispatch(setrowGroupModel(rows))
		}
	}

	function onCellValueChanged(e) {
		const { attribute_name } = e.data

		const payload = {
			attribute_name: e.data.attribute_name,
		}
		if (!payload.attribute_name) {
			toast.error('Attribute Name is required')
			props.refresh()
			return
		}
		axios.post(`/model-custom-attributes/update/${e.data.id}`, payload).then(response => {
			if (response.status === 201) {
				toast.error(response.data.message)
				props.refresh()
			} else {
				toast.success('Attribute updated Successfully.')
				props.refresh()
			}
		}).catch(err => {
			console.log('212=>', err);
			toast.error('Something went wrong!')
		})
	}

	// useEffect(()=>{
	// 	onGridReady()
	// },[props.endUsersAccounts])

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;

		const rows = params.api.getCellRanges();

		if (rows.length != 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex != endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}
	}

	const generateHeaderLabel = (header) => {
		console.log(header)
		if (header === "attribute_name") {
			return 'Model Attribute';
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')


	}

	useEffect(() => {
		return () => {
			dispatch(setQuickFilter(null))
		}
	}, [])

	useEffect(() => {
		gridRef?.current?.api?.setQuickFilter(
			query_data
		);
		// if(Object.keys(filterModel).length !== 0){
		// 	setTimeout(()=>{
		// 		gridRef.current.api.setFilterModel(filterModel);
		// 	},0)
		// }
	}, [query_data])

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	const handleChildClick = (value) => {
		setTabValue(value)
	};

	// logs
	function formatLogs(data) {
		return data.map((item) => {
			return {
				id: item.id,
				action_id: `act${item.id}`,
				action_date_and_time: item.created_at,
				attribute_name: item?.model_custom_attributes?.attribute_name || item.attribute_name,
				name: item.user_name,
				action: item.action_name,
				description: item.comment,
				previous_value: item.previous_data,
				current_value: item.current_data,
				field_name: item.action_field_name,
				user_role: item.user_role_name
			}
		})
	}

	function getLogs() {
		setLoadingActivityLog(true)

		axios.get('/model-custom-attributes/activities')
			.then(({ data }) => {
				setLoadingActivityLog(false)

				setLogs(formatLogs(data.data.activities));
			})
			.catch(() => {
				console.log('cannot fetch logs');
			})
	}

	function handleAddModelAttribute() {
		dispatch(openFormViewerDialog())
	}
	useEffect(() => {
		(tabValue === 1) && getLogs()
	}, [tabValue])

	useEffect(() => {
		setTabValue(tab_value)
	}, [tab_value]);

	return (
		<>
			{(tabValue === 0) && <AgGridFilterGroupView tableRef={gridRef} setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="custom_attributes" logs={logs} displayTableName="Model Attributes"
				onClick={handleChildClick} onClickAddButton={handleAddModelAttribute}
				addPermission={props.createModelAttributePermission}
				key={isGridReady}
			/>}
			{(tabValue === 1) && (<ActivityAgGridListing module="custom_attributes" logs={logs} displayTableName="Model Attributes"
				addPermission={props.createModelAttributePermission}
				loadingActivityLog={loadingActivityLog}
			/>)}
			{(tabValue === 0) && <div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 105,
					fontSize: '12px'
				}}
			>
				<AgGridReact
					ref={gridRef}
                    theme="legacy"
					suppressRowClickSelection
					onGridReady={onGridReady}
					animateRows
					rowData={props.endUsersAccounts}
					rowHeight={30}
                    headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}
					groupHeaderHeight={1}
					floatingFiltersHeight={40}
					components={frameworkComponents}

					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}

					onFilterChanged={onFilterChanged}

					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}

					cacheQuickFilter

					pagination
					defaultColDef={{
						enableRowGroup: true,
						resizable: true
					}}
					columnDefs={[{
						lockPosition: true,
						rowSelection: "single",
						width: 100,
						minWidth: 100,
						maxWidth: 100,
						suppressSizeToFit: true,
						headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
						pinned: 'right',
						className: "action_field",
						lockPinned: true,
						cellRenderer: ({ data }) => {
							if (data) {
								return (
									<>
										{props.updateModelAttributePermission && <Tooltip id="edit" title="Edit" placement="top">
											{/* <Icon 
												onClick={() => handelEdit(data)} 
												style={{
														color: '#1d2939',
														paddingBottom: '3px',
														paddingRight:'30px',
														fontSize:'15px',
														cursor:'pointer'
													}}
												>
													edit
												</Icon> */}
											<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-pencil" onClick={() => handelEdit(data)} />
										</Tooltip>}
										{props.deleteModelAttributePermission && <Tooltip id="delete" title="Delete" placement="top">
											{/* <Icon 
												onClick={() => handelDelete(data)} 
												style={{
													color: '#1d2939',
													paddingBottom: '3px',
													paddingRight:'30px',
													fontSize:'15px',
													cursor:'pointer'
												}}
											>
												delete
											</Icon> */}
											<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-trash" onClick={() => handelDelete(data)} />
										</Tooltip>}
									</>
								)
							}
							return (<></>)

						}
					},
					...tableHeaders.filter((item) => !skipHeader.includes(item)).map(header => {
						return {
							field: header,
							key: header,
							suppressSizeToFit: true,
							headerName: generateHeaderLabel(header),
							sortable: true,
							headerComponent: (props) => (CustomFilter(props, header, gridRef)),
							filter: "agTextColumnFilter",
							flex: 1,
							minWidth: 200,
							editable: header != 'source' && props.updateModelAttributePermission,
							onCellValueChanged,
						}
					})
					]}
				/>
			</div>}
			{/* {
				modalData && (
					<GeneralModal
						open={modalData}
						title={'Delete Attribute'}
						text={<h4>Are you sure to delete this Attribute named as <b>{modalData.attribute_name}</b>?</h4>}
						handleClose={handleClose}
						handleConfirm={handleConfirm}
					/>
				)
			} */}
			{
				openDeleteDialog &&
				<DeleteConfirmModal
					openAlerModal={openDeleteDialog}
					module="Model Attribute"
					handleCloseAlertModal={handleClose}
					handleAlertModal={handleConfirm}
				/>
			}
		</>
	);
}

export default ListView
